module.exports = __webpack_public_path__ + "static/media/img_placeholder.e179cdda.png";